module.exports = __webpack_public_path__ + "static/media/beta-icon.6458efcd.png";